<template>
	<v-dialog
		v-model="dialog"
		max-width="1200px"
		width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn class="mt-2" color="secondary" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-list-box-outline</v-icon>
				工程チェック結果一覧</v-btn
			>
		</template>

		<v-card :tile="$vuetify.breakpoint.xs" min-height="60vh">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">チェック結果</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-sheet elevation="0" class="pa-2" height="auto">
				<p class="text-body-2 mt-2">
					製造番号：{{ common.productNumberByOrderIndividualInfo(order_individual_info) }}
					<br />
					シート名：{{ checkSheetName }}
				</p>
				<h6 class="text-h6 font-weight-bold mt-2">
					{{ check_process.check_process_type.name }}
				</h6>
				<div class="table-container">
					<table width="100%" class="mt-2 show-dialog-table">
						<tbody>
							<tr>
								<th class="font-weight-bold w200">回数 / 数量</th>
								<td v-for="(checkUnit, i) in check_process.check_units" :key="checkUnit.id">
									{{ i + 1 }}回 / {{ checkUnit.quantity }}台
								</td>
							</tr>

							<tr
								v-for="checkItem in check_process.check_process_type.check_items"
								:key="checkItem.id"
							>
								<th class="font-weight-bold">
									{{ checkItem.name }}
								</th>
								<v-hover
									v-for="checkUnit in check_process.check_units"
									v-slot="{ hover }"
									:key="checkUnit.id"
									close-delay="200"
									open-delay="200"
								>
									<td class="w200">
										{{ value(checkUnit, checkItem) }}
										<v-icon
											v-if="hover"
											class="edit-btn"
											absolute
											@click="openEditDialog(checkUnit, checkItem)"
											>mdi-pencil-box</v-icon
										>
									</td>
								</v-hover>
							</tr>
						</tbody>
					</table>
				</div>
			</v-sheet>
			<CheckValueEditDialog
				@check="updateCheckValue"
				:check_value.sync="selectedCheckValue"
				:check_item="selectedCheckItem"
				:check_process="check_process"
				:dialog.sync="editDialog"
			/>
		</v-card>
	</v-dialog>
</template>

<script>
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import CheckValueEditDialog from "./CheckValueEditDialog.vue"

export default {
	props: {
		editable: {
			type: Boolean,
			default: false,
		},
		check_process: {
			type: null,
			required: false,
		},
		order_individual_info: {
			type: null,
			required: false,
		},
		checkSheetName: {
			type: String,
			required: false,
		},
	},
	components: {
		ShowDetailRecord,
		CheckValueEditDialog,
	},
	data() {
		return {
			editDialog: false,
			remainingQuantity: 0,
			selectedCheckItem: null,
			selectedCheckValue: null,
			common,
			dialog: false,
		}
	},
	methods: {
		openEditDialog(checkUnit, checkItem) {
			this.selectedCheckItem = checkItem
			this.selectedCheckValue = this.checkValue(checkUnit, checkItem)
			this.editDialog = true
		},
		value(checkUnit, checkItem) {
			const checkValue = this.checkValue(checkUnit, checkItem)
			return common.value(checkItem, checkValue?.value)
		},
		checkValue(checkUnit, checkItem) {
			return checkUnit.check_values.find((c) => c.check_item_id == checkItem.id)
		},
		updateCheckValue(unit, item) {
			this.check_process.check_units.forEach((checkUnit) => {
				if (checkUnit.id == unit.id) {
					const oldCheckValue = checkUnit.check_values.find((c) => c.check_item_id == item.id)
					if (oldCheckValue) {
						let newCheckValue = unit.check_values.find((c) => c.check_item_id == item.id)
						oldCheckValue.value = newCheckValue.value
					}
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.w200 {
	position: relative;
	width: 200px;
	min-width: 200px;
}
.edit-btn {
	top: 0;
}
</style>
